/**
 * Kanban Constants
 */
// Constants for public events
/** @private */
export const actionBegin = 'actionBegin';
/** @private */
export const actionComplete = 'actionComplete';
/** @private */
export const actionFailure = 'actionFailure';
/** @private */
export const cardClick = 'cardClick';
/** @private */
export const cardDoubleClick = 'cardDoubleClick';
/** @private */
export const cardRendered = 'cardRendered';
/** @private */
export const queryCellInfo = 'queryCellInfo';
/** @private */
export const dataBinding = 'dataBinding';
/** @private */
export const dataBound = 'dataBound';
/** @private */
export const dragStart = 'dragStart';
/** @private */
export const drag = 'drag';
/** @private */
export const dragStop = 'dragStop';
/** @private */
export const documentClick = 'document-click';
/** @private */
export const dialogOpen = 'dialogOpen';
/** @private */
export const dialogClose = 'dialogClose';
// Constants for internal events
/** @private */
export const contentReady = 'content-ready';
/** @private */
export const dataReady = 'data-ready';
/** @private */
export const bottomSpace = 25;
/** @private */
export const cardSpace = 16;
/** @private */
export const toggleWidth = 50;
/** @hidden */
export const dataSourceChanged = 'dataSourceChanged';
/** @hidden */
export const dataStateChange = 'dataStateChange';
/** @private */
export const columnDragStart = 'columnDragStart';
/** @private */
export const columnDrag = 'columnDrag';
/** @private */
export const columnDrop = 'columnDrop';
